var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBillingIcon = function SvgBillingIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3H13.5859L19 8.41406V20C19 20.5477 18.5477 21 18 21H5.99023C5.44935 21 5.00053 20.5548 5 20.001L5.00977 4.00098V4C5.00977 3.44575 5.4588 3 6 3Z",
    stroke: "#499CE0",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8L10.59 9.41L12.17 11H8V13H12.17L10.59 14.59L12 16L16 12L12 8Z",
    fill: "#499CE0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBillingIcon);
export { ForwardRef as ReactComponent };